import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcChatbotH32(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.754 18.749c.69 0 1.25.56 1.25 1.25v.012a1.25 1.25 0 0 1-2.5 0v-.012c0-.69.56-1.25 1.25-1.25M21.004 19.999a1.25 1.25 0 0 0-2.5 0v.012a1.25 1.25 0 0 0 2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.504 7.666a3.75 3.75 0 1 1 4.5 3.675v.948c6.574.51 11.75 6.006 11.75 12.711v.5a3.25 3.25 0 0 1-3.25 3.25h-19a3.25 3.25 0 0 1-3.25-3.25V25c0-6.874 5.44-12.478 12.25-12.74v-.919a3.75 3.75 0 0 1-3-3.675m3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-.25 8.334c-6.213 0-11.25 5.037-11.25 11.25v.5c0 .966.783 1.75 1.75 1.75h19a1.75 1.75 0 0 0 1.75-1.75V25c0-6.213-5.037-11.25-11.25-11.25",
    clipRule: "evenodd"
  }));
}
var IcChatbotH32 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcChatbotH32));

export { IcChatbotH32 as I };
